import StorageViz from './StorageViz'

export default StorageViz
